<template>
<div class="container-fluid">
  <div class="row mt-5">
  <div class="col-md-4 offset-md-4">
    <h3 class="text-center">login</h3>
  <form @submit.prevent="login">
    <fieldset>
      <div class="form-group">
        <label for="email">Email address</label>
        <input v-validate="'required|email'" v-model="user.email" type="email" class="form-control" name="email" aria-describedby="emailHelp" placeholder="Enter email" :class="{ 'is-invalid': submitted && errors.has('email') }" />
        <div v-if="submitted && errors.has('email')" class="invalid-feedback">{{ errors.first('email') }}</div>      </div>
      <div class="form-group">
        <label for="password">Password</label>
        <input v-model="user.password" v-validate="'required'" type="password" class="form-control" name="password" placeholder="Enter password" :class="{ 'is-invalid': submitted && errors.has('password') }" />
        <div v-if="submitted && errors.has('password')" class="invalid-feedback">{{ errors.first('password') }}</div>
      </div>
      <button type="submit" class="btn btn-primary pull-right">Login</button>
    </fieldset>
  </form>
  </div>
</div>
</div>
</template>

<script>
import axios from 'axios'
export default {
  data: () => ({
    user: {
      email: '',
      password: '',
    },
    submitted: false,
  }),
  methods: {
    login() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          axios.post(`${process.env.VUE_APP_API_URL}/api/auth/login`, this.user).then((res) => {
            localStorage.setItem('token', res.data.token);
            this.$swal.fire({
              position: 'top-end',
              type: 'success',
              title: 'You have been logged in.',
              showConfirmButton: false,
              timer: 1500,
            });
            this.$router.go();
          }).catch((err) => {
            if (err.response.status === 422) {
              this.errors.add({
                field: 'email',
                msg: err.response.data.message,
              });
            }
          });
        }
      });
    },
  },
};
</script>
